module.exports = __webpack_public_path__ + "static/media/manager-b-5.4136dc6c.png";